import { useMemo } from "react";
import { checkUserPermissionFunc } from "../components/common/CommonFunctions";

// Training permission checks aligned with backend TrainingModule keys
// (my_trainings, team_trainings, assign_training) and training/urls.py name= values.
export const useTrainingPermissions = () => {
    return useMemo(() => {
        const myTrainings = checkUserPermissionFunc("training", "my_trainings", "SubMenu");
        const teamTrainings = checkUserPermissionFunc("training", "team_trainings", "SubMenu");
        const assignTraining = checkUserPermissionFunc("training", "assign_training", "SubMenu");
        const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false")
            || JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
        const allow = (p) => isAdmin || !!p?.permission;
        return {
            canViewMyTrainings: allow(myTrainings),
            canViewTeamTrainings: allow(teamTrainings),
            canAssignTraining: allow(assignTraining),
        };
    }, []);
};

export default useTrainingPermissions;
